(function() {
  function initProductGuard(guard) {
    if (!guard || guard.dataset.productGuardInitialized === 'true') return;
    guard.dataset.productGuardInitialized = 'true';

    var sectionRoot = guard.closest('[id^="shopify-section-"]');
    if (!sectionRoot) return;

    sectionRoot.setAttribute('data-product-access-ready', 'false');

    var guardMode = guard.getAttribute('data-guard-mode') || 'waitgate';
    var statusUrl = guard.getAttribute('data-product-access-status-url') || '';
    var purchaseClaimUrl = guard.getAttribute('data-purchase-claim-url') || '';
    var redirectUrl = guard.getAttribute('data-product-access-redirect') || '/apps/nft-gate';
    var dashboardGateStorageKey = 'nft_gate_token_main';
    var purchaseRecipientReady = false;
    var purchaseRecipientPending = false;
    var purchaseWalletAddress = '';
    var purchaseClaim = '';
    var purchaseSubmitted = false;
    var isRequiredTokenPurchase = guardMode === 'required-token';

    function stripSensitiveParams() {
      if (!window.history || !window.URLSearchParams) return;

      var params = new URLSearchParams(window.location.search);
      var hashParams = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      var changed = false;

      ['gate_token', 'unlock_token', 'product_access_token'].forEach(function(key) {
        if (params.has(key)) {
          params.delete(key);
          changed = true;
        }

        if (hashParams.has(key)) {
          hashParams.delete(key);
          changed = true;
        }
      });

      if (!changed) return;

      var cleanQuery = params.toString();
      var cleanHash = hashParams.toString();
      var cleanUrl = window.location.pathname + (cleanQuery ? '?' + cleanQuery : '') + (cleanHash ? '#' + cleanHash : '');
      window.history.replaceState({}, document.title, cleanUrl);
    }

    function getProductAccessTokenFromUrl() {
      if (!window.URLSearchParams) return '';

      var hashParams = new URLSearchParams((window.location.hash || '').replace(/^#/, ''));
      var queryParams = new URLSearchParams(window.location.search || '');
      return hashParams.get('product_access_token') || queryParams.get('product_access_token') || '';
    }

    function unlockSection() {
      sectionRoot.setAttribute('data-product-access-ready', 'true');
    }

    function refreshCheckoutSurface() {
      sectionRoot.querySelectorAll('.accelerated-checkout-block, .shopify-payment-button').forEach(function(element) {
        element.removeAttribute('hidden');
        element.hidden = false;
        element.style.removeProperty('display');
        element.style.removeProperty('pointer-events');
      });

      sectionRoot.querySelectorAll('shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button button, .shopify-payment-button__button').forEach(function(element) {
        element.removeAttribute('disabled');
        element.removeAttribute('aria-disabled');
        element.removeAttribute('inert');
        element.disabled = false;
        element.style.removeProperty('pointer-events');
      });

      sectionRoot.dispatchEvent(new CustomEvent('product-access:ready', { bubbles: true }));
    }

    function scheduleCheckoutRefresh() {
      refreshCheckoutSurface();
      window.setTimeout(refreshCheckoutSurface, 250);
      window.setTimeout(refreshCheckoutSurface, 1000);
    }

    function redirectToGate(nextUrl) {
      window.location.replace(nextUrl || redirectUrl);
    }

    function getStoredDashboardGateToken() {
      try {
        return window.sessionStorage ? window.sessionStorage.getItem(dashboardGateStorageKey) || '' : '';
      } catch (error) {
        return '';
      }
    }

    function setButtonsLocked(locked) {
      var buttons = sectionRoot.querySelectorAll('button[name="add"], .shopify-payment-button button, .shopify-payment-button__button, .sticky-add-to-cart__button');

      buttons.forEach(function(button) {
        button.disabled = locked;
        button.setAttribute('aria-disabled', locked ? 'true' : 'false');
      });

      if (!locked) {
        scheduleCheckoutRefresh();
      }
    }

    function setFormProperty(form, name, value) {
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    }

    function attachPurchaseRecipient(walletAddress, purchaseClaim) {
      sectionRoot.querySelectorAll('form[data-type="add-to-cart-form"], form[action*="/cart/add"]').forEach(function(form) {
        setFormProperty(form, 'properties[_better_human_wallet_address]', walletAddress);
        setFormProperty(form, 'properties[_better_human_purchase_claim]', purchaseClaim);
      });
    }

    function preparePurchaseRecipient() {
      if (!purchaseClaimUrl) return Promise.reject(new Error('Purchase recipient unavailable'));

      purchaseRecipientPending = true;
      var dashboardGateToken = getStoredDashboardGateToken();
      return fetch(purchaseClaimUrl, {
        credentials: 'include',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          ...(dashboardGateToken ? { Authorization: 'Bearer ' + dashboardGateToken } : {})
        }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Purchase recipient unavailable');
          return response.json();
        })
        .then(function(payload) {
          if (!payload || !payload.walletAddress || !payload.purchaseClaim) {
            throw new Error('Purchase recipient unavailable');
          }
          purchaseWalletAddress = payload.walletAddress;
          purchaseClaim = payload.purchaseClaim;
          attachPurchaseRecipient(purchaseWalletAddress, purchaseClaim);
          purchaseRecipientPending = false;
          purchaseRecipientReady = true;
          updateGuard();
        })
        .catch(function() {
          purchaseRecipientPending = false;
          purchaseRecipientReady = false;
          setButtonsLocked(true);
          guard.textContent = isRequiredTokenPurchase
            ? 'We could not verify that this wallet owns the required matching Star Token. Re-enter through the secure gate and try again.'
            : 'We could not verify the wallet for this Star Token purchase. Re-enter through the game dashboard and try again.';
        });
    }

    function updateGuard() {
      if (guardMode === 'member-pass') {
        setButtonsLocked(false);
        guard.textContent = 'Energy Quest Star Token verified. You can purchase the VR Room Pass from this page.';
        return;
      }

      if (!purchaseRecipientReady) {
        if (!purchaseRecipientPending) {
          preparePurchaseRecipient();
        }
        setButtonsLocked(true);
        guard.textContent = isRequiredTokenPurchase
          ? 'Verifying matching Star Token ownership for this wallet.'
          : 'Preparing your verified wallet for this Star Token purchase.';
        return;
      }

      setButtonsLocked(false);
      if (isRequiredTokenPurchase) {
        guard.textContent = purchaseSubmitted
          ? 'One collectible was added with a verified matching Star Token ownership claim.'
          : 'Matching Star Token verified. You may purchase one of this collectible.';
      } else {
        guard.textContent = purchaseSubmitted
          ? 'Purchase added to cart. Your next challenge unlocks only after payment and NFT mint confirmation.'
          : 'Purchase this Star Token. Your next challenge unlocks after its NFT is minted to your wallet.';
      }
    }

    sectionRoot.addEventListener('submit', function(event) {
      if (purchaseRecipientReady) {
        attachPurchaseRecipient(purchaseWalletAddress, purchaseClaim);
      }
      if (guardMode !== 'member-pass' && !purchaseRecipientReady) {
        event.preventDefault();
        updateGuard();
      }
    }, true);

    document.addEventListener('cart:update', function(event) {
      if (!event || !event.detail || !event.detail.data || event.detail.data.didError) return;
      if (String(event.detail.data.source || '') !== 'product-form-component') return;

      purchaseSubmitted = true;
      updateGuard();
    });

    window.addEventListener('pageshow', updateGuard);

    function initializeGuard() {
      stripSensitiveParams();
      unlockSection();

      if (guardMode === 'member-pass') {
        setButtonsLocked(false);
        guard.textContent = 'Energy Quest Star Token verified. You can purchase the VR Room Pass from this page.';
        return;
      }

      updateGuard();
    }

    if (window.Shopify && window.Shopify.designMode) {
      purchaseRecipientReady = true;
      initializeGuard();
      return;
    }

    if (!statusUrl) {
      redirectToGate();
      return;
    }

    var dashboardGateToken = getStoredDashboardGateToken();
    var productAccessToken = getProductAccessTokenFromUrl();
    fetch(statusUrl, {
      credentials: 'include',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        ...(productAccessToken ? { 'X-Product-Access-Token': productAccessToken } : {}),
        ...(dashboardGateToken ? { Authorization: 'Bearer ' + dashboardGateToken } : {})
      }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Product access unavailable');
        return response.json();
      })
      .then(function(payload) {
        if (payload && payload.authenticated) {
          initializeGuard();
          return;
        }

        redirectToGate(payload && payload.redirectUrl);
      })
      .catch(function() {
        redirectToGate();
      });
  }

  function initAll() {
    document.querySelectorAll('[data-star-token-product-guard]').forEach(initProductGuard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
